<template>
  <div class="posterPage posterPageWrap">
    <img style="width: 100%" :src="tForm.pageBg" alt="" />
    <div class="posterPage-right">
      <div v-for="(item, index) in btnRight" :key="index">
        <div class="posterPage-right1" v-if="item.btnType === 'b'" @click="showBtnContent(item)" :style="`background: ${item.btnColor};transform: translateY(${item.btnOffset}vw)`">
          {{ item.btnName }}
        </div>
        <div v-else @click.stop="hrefClick(item)" class="posterPage-right1" :style="`background: ${item.btnColor};transform: translateY(${item.btnOffset}vw)`">{{ item.btnName }}</div>
      </div>
    </div>
    <div class="posterPage-bottom">
      <div v-for="(item, index) in btnBottom" :key="index">
        <div class="posterPage-bottom1" v-if="item.btnType === 'b'" @click="showBtnContent(item)" :style="`background: ${item.btnColor};transform: translateY(${item.btnOffset}vw)`">
          {{ item.btnName }}
        </div>
        <div v-else @click.stop="hrefClick(item)" class="posterPage-bottom1" :style="`width: ${item.btnWidth}vw;background: ${item.btnColor};transform: translateY(${item.btnOffset}vw)`">{{ item.btnName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  data() {
    return {
      tForm: {
        btnList: [],
        endTime: "",
        pageBg: "",
      },
      btnRight: [],
      btnBottom: [],
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    activity() {
      return this.$store.getters.activity;
    },
    accounts() {
      return this.$store.getters.accounts;
    },
    activities() {
      return this.$store.getters.activities;
    },
    awards() {
      return this.$store.getters.awards;
    },
    verifications() {
      return this.$store.getters.verifications;
    },
    checkin() {
      return this.$store.getters.checkin;
    },
    isAccountMobile() {
      return this.$store.getters.isAccountMobile;
    },
    isCaptcha() {
      return this.$store.getters.isCaptcha;
    },
    isVerificationMobile() {
      return this.$store.getters.isVerificationMobile;
    },
    buttonName() {
      return this.activity.buttonName ? this.activity.buttonName : this.activities && Object.keys(this.activities).length ? "参与游戏" : "立即领取";
    },
  },
  mounted() {
    function urlQuery(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
    let activity = urlQuery("activity");
    this.$api.activity.poster
      .poster({
        posterId: activity,
      })
      .then((response) => {
        let fixarr = [];
        try {
          if (response.datas) {
            fixarr = JSON.parse(response.datas);
          }
        } catch (error) {}
        fixarr = fixarr.reverse();
        document.title = response.name;
        let door = true;
        fixarr.forEach((v1) => {
          if (door) {
            let fixstr = v1.endTime.replace(/(-)/g, "/");
            if (new Date(fixstr).getTime() > new Date().getTime()) {
              door = false;
              this.tForm = v1;
            }
          }
        });
        if (!this.tForm.endTime) {
          this.tForm = fixarr[fixarr.length - 1] || {};
        }
        this.btnRight = this.tForm.btnList.filter((v1) => v1.btnPosi === "right");
        this.btnBottom = this.tForm.btnList.filter((v1) => v1.btnPosi === "bottom");
      });

    // 浏览页面
    window.setTimeout(() => {
      this.$store.dispatch("onUserLogSend", {
        pageName: "海报页",
        behavior: { visist: "海报页" },
      });
    }, 500);
  },
  methods: {
    hrefClick(i) {
      window.location.href = i.btnContent;
    },
    showBtnContent(i) {
      Dialog.alert({
        message: i.btnContent,
        messageAlign: "left",
      }).then(() => {});
    },
  },
};
</script>

<style scoped>
.posterPageWrap {
}
.posterPage {
  font-size: 0;
}
.posterPage-right {
  position: fixed;
  right: 0;
  top: 40%;
  transform: translateY(-50%);
  z-index: 200;
}
.posterPage-right1 {
  width: 4vw;
  color: #fff;
  font-size: 3.7333vw;
  margin: 4vw 0;
  padding: 1.6vw;
  word-break: break-all;
  border-radius: 2.1333vw 0 0 2.1333vw;
  border: 1px solid #fff;
  border-right: 0;
  text-align: center;
}
.posterPage-bottom {
  position: absolute;
  left: 0;
  top: 100vw;
  width: 100%;
  z-index: 200;
}
.posterPage-bottom1 {
  width: 50vw;
  height: 10.6667vw;
  line-height: 10.6667vw;
  font-size: 4.2667vw;
  color: #fff;
  text-align: center;
  border-radius: 10.6667vw;
  margin: 4vw auto;
}
</style>
